import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

//import Block from './Block';
import Loading from '../../dialogs/loading';
import Alert from './Alert';

import Grid from '@material-ui/core/Grid';
import BlueButton from '../../buttons/BlueButton';

class Blocks extends React.Component {

    constructor(props) {
        super(props);

        const { alerts, info, pending } = this.props;
        const locals = info && info.security && info.security.locals ? info.security.locals : [];

        this.state = {
            isLoading: true,
            locals: locals,
            alerts: alerts,
            arr:
                alerts &&
                alerts.length > 0 &&
                alerts
                    .sort((a, b) => (a.fechaAlta.date > b.fechaAlta.date ? -1 : 1))
                    .map((alert, i) => {
                        return (
                            <Alert
                                pending={pending}
                                key={'alert-' + alert.id}
                                data={alert}
                                last={alerts.length === i + 1}
                                local={locals.find((l) => l.id === alert.idLocal)}
                            />
                        );
                    }),
        };
    }

    static getDerivedStateFromProps(props, state) {
        const { alerts, info, pending, index, pagination } = props;
        const locals = info && info.security && info.security.locals ? info.security.locals : [];

        if (
            index !== state.index ||
            pagination !== state.pagination ||
            locals !== state.locals ||
            alerts !== state.alerts
        ) {
            state.index = index;
            state.pagination = pagination;
            state.locals = locals;
            state.alerts = alerts;
            state.arr =
                alerts &&
                alerts.length > 0 &&
                alerts
                    .sort((a, b) => (a.fechaAlta.date > b.fechaAlta.date ? -1 : 1))
                    .map((alert, i) => {
                        return (
                            <Alert
                                pending={pending}
                                key={'alert-' + alert.id}
                                data={alert}
                                last={alerts.length === i + 1}
                                local={locals.find((l) => l.id === alert.idLocal)}
                            />
                        );
                    });
            state.isLoading = false;
            return state;
        }
        return null;
    }

    render() {
        const { index, pagination, arr } = this.state;
        const length = arr.length;
        const data = [...arr].splice(0, index + pagination);

        return this.state.isLoading ? (
            <Loading open opacity />
        ) : (
            <div id="blocks" className="flex_full_column">
                {data}
                {length > index + pagination && (
                    <Grid
                        container
                        justify="center"
                        className={'flex_grow_1 align_center margin_top_24'}
                    >
                        <Grid item xs={10} sm={6} className="padding_bottom_12">
                            <BlueButton id="next" onClick={this.props.next} />
                        </Grid>
                    </Grid>
                )}
            </div>
        );
    }
}

Blocks.propTypes = {
    history: PropTypes.object.isRequired,
    info: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
    return {
        info: state.info,
    };
}

export default connect(
    mapStateToProps,
    null,
)(withRouter(Blocks));



// WEBPACK FOOTER //
// ./src/components/complex/alerts/Blocks.js